var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp_avatar",style:({
    'background-color': this.$props.propBgColor,
    color: this.$props.propColor,
  })},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require("@/gfx/avatar.svg")}})])}]

export { render, staticRenderFns }